import { global_get_started_box } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type GetStartedBoxProps } from './GetStartedBox';
export const getStartedBoxSchema = global_get_started_box.transform<GetStartedBoxProps>(data => ({
  ctaHref: data.cta.href,
  ctaText: data.cta.title,
  title: data.title
}));